import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg404 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M38.82 153.15V45.05a10.3 10.3 0 0 1 10.3-10.3h-3.87a10.3 10.3 0 0 0-10.3 10.3v108.1a10.3 10.3 0 0 0 10.3 10.3h3.86a10.3 10.3 0 0 1-10.3-10.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint0_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M38.82 153.15V45.05a10.3 10.3 0 0 1 10.3-10.3h-3.87a10.3 10.3 0 0 0-10.3 10.3v108.1a10.3 10.3 0 0 0 10.3 10.3h3.86a10.3 10.3 0 0 1-10.3-10.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint1_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M49.11 34.75h67.25a10.3 10.3 0 0 1 10.29 10.3v108.1a10.3 10.3 0 0 1-10.3 10.3H49.1a10.3 10.3 0 0 1-10.3-10.3V45.04a10.3 10.3 0 0 1 10.3-10.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint2_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M126.65 47.48H38.82v103.23h87.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint3_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M82.73 154.12a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 0 0 0-5.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint4_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M77.21 41.12h12.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint5_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.51 141h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint6_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.51 144.6h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint7_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M55.88 141h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint8_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M55.88 144.6h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint9_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.51 53.6h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint10_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.51 57.17h23.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint11_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.9 62.54h52.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint12_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.9 66.13h52.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M55.21 47.48a8.31 8.31 0 0 0 16.63 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint13_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M55.21 47.48a8.31 8.31 0 0 0 16.63 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint14_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M38.82 134.84h87.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M64.6 104.34H53.98l11.46-15.92-5-3.6-18.46 25.67H64.6v15.03h6.14V99.03H64.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M116.47 99.03v5.31h-10.62l11.46-15.92-5-3.6-18.46 25.67h22.62v15.03h6.14V99.03z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "M92.2 92.33a6.3 6.3 0 0 0-6.28-6.29h-4.86a6.3 6.3 0 0 0-6.28 6.28v26.92a6.3 6.3 0 0 0 6.28 6.28h4.86a6.3 6.3 0 0 0 6.28-6.28zm-6.15 27.05h-5.13V92.19h5.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "m38.82 73.42 14.64 6.64 14.63-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint15_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m38.82 73.42 14.64 6.64 14.63-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "m68.1 73.42 14.63 6.64 14.64-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint16_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m68.1 73.42 14.63 6.64 14.64-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "m97.37 73.42 14.64 6.64 14.64-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint17_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m97.37 73.42 14.64 6.64 14.64-6.64z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "m158.45 104.1-4.83 11.2-11.6-.92-4.93 10.54-11.6-.92-5.3 10.36-11.56-1.33a60.3 60.3 0 0 0 40.63 27.88L195 128.95c-14.28-3.09-29.05-12.31-36.55-24.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint18_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m158.45 104.1-4.83 11.2-11.6-.92-4.93 10.54-11.6-.92-5.3 10.36-11.56-1.33a60.3 60.3 0 0 0 40.63 27.88L195 128.95c-14.28-3.09-29.05-12.31-36.55-24.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint19_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m136.4 134.92 34.15-1.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint20_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m155.52 121.49-3.7 25.15"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint21_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M151.47 70.81h10.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint22_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.48 75.82V65.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint23_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m16.26 122.3 7.08 7.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint24_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m16.26 129.38 7.08-7.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint25_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m165.57 161.64 3.61 3.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint26_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m165.57 165.25 3.61-3.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint27_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m5 157.57 3.1 5.11 3.64-7.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint28_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M167.37 45.22h5.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#404_svg__paint29_linear_4001_7864)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M170.1 47.95V42.5"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint0_linear_4001_7864",
				x1: 42.032,
				x2: 16.638,
				y1: 144.304,
				y2: 66.277,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint1_linear_4001_7864",
				x1: 82.731,
				x2: 78.215,
				y1: 144.302,
				y2: 58.248,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint2_linear_4001_7864",
				x1: 82.733,
				x2: 79.825,
				y1: 135.356,
				y2: 66.267,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint3_linear_4001_7864",
				x1: 82.733,
				x2: 82.591,
				y1: 159.151,
				y2: 155.196,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint4_linear_4001_7864",
				x1: 83.587,
				x2: 83.585,
				y1: 41.969,
				y2: 41.299,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint5_linear_4001_7864",
				x1: 97.466,
				x2: 97.465,
				y1: 141.86,
				y2: 141.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint6_linear_4001_7864",
				x1: 97.466,
				x2: 97.465,
				y1: 145.444,
				y2: 144.774,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint7_linear_4001_7864",
				x1: 67.829,
				x2: 67.828,
				y1: 141.86,
				y2: 141.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint8_linear_4001_7864",
				x1: 67.829,
				x2: 67.828,
				y1: 145.444,
				y2: 144.774,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint9_linear_4001_7864",
				x1: 97.466,
				x2: 97.465,
				y1: 54.443,
				y2: 53.772,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint10_linear_4001_7864",
				x1: 97.466,
				x2: 97.465,
				y1: 58.026,
				y2: 57.356,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint11_linear_4001_7864",
				x1: 83.156,
				x2: 83.156,
				y1: 63.396,
				y2: 62.725,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint12_linear_4001_7864",
				x1: 83.156,
				x2: 83.156,
				y1: 66.98,
				y2: 66.309,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint13_linear_4001_7864",
				x1: 63.526,
				x2: 63.429,
				y1: 54.485,
				y2: 48.973,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint14_linear_4001_7864",
				x1: 82.733,
				x2: 82.733,
				y1: 135.686,
				y2: 135.016,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint15_linear_4001_7864",
				x1: 53.456,
				x2: 53.42,
				y1: 79.069,
				y2: 74.622,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint16_linear_4001_7864",
				x1: 82.733,
				x2: 82.697,
				y1: 79.069,
				y2: 74.622,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint17_linear_4001_7864",
				x1: 112.009,
				x2: 111.973,
				y1: 79.069,
				y2: 74.622,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint18_linear_4001_7864",
				x1: 151.812,
				x2: 150.916,
				y1: 152.465,
				y2: 114.392,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint19_linear_4001_7864",
				x1: 153.473,
				x2: 153.472,
				y1: 134.752,
				y2: 133.989,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint20_linear_4001_7864",
				x1: 153.667,
				x2: 149.799,
				y1: 142.902,
				y2: 126.976,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint21_linear_4001_7864",
				x1: 156.478,
				x2: 156.476,
				y1: 71.664,
				y2: 70.994,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint22_linear_4001_7864",
				x1: 156.978,
				x2: 154.843,
				y1: 74.332,
				y2: 68.382,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint23_linear_4001_7864",
				x1: 19.8,
				x2: 19.631,
				y1: 128.324,
				y2: 123.581,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint24_linear_4001_7864",
				x1: 19.8,
				x2: 19.631,
				y1: 128.324,
				y2: 123.581,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint25_linear_4001_7864",
				x1: 167.373,
				x2: 167.287,
				y1: 164.713,
				y2: 162.293,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint26_linear_4001_7864",
				x1: 167.373,
				x2: 167.287,
				y1: 164.713,
				y2: 162.293,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint27_linear_4001_7864",
				x1: 8.37,
				x2: 8.162,
				y1: 161.545,
				y2: 156.438,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint28_linear_4001_7864",
				x1: 170.105,
				x2: 170.101,
				y1: 46.071,
				y2: 45.4,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "404_svg__paint29_linear_4001_7864",
				x1: 170.605,
				x2: 169.914,
				y1: 47.139,
				y2: 43.61,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default Svg404;
